<template>
  <div class="screen" v-if="seen">
    <img src="@/assets/logo-white.svg" width="250" height="50"/>
  </div>
</template>
<style scoped>
.screen {
  background: #012e54;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: fixed;
  width: 100%;
}
</style>
<script>
export default {
  data () {
    return {
      seen: false
    }
  },
  methods: {
    load () {
      this.seen = true
    },
    close () {
      this.seen = false
    }
  }
}
</script>
